import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => {
  const lastUpdated = 'January 15, 2024';

  const sections = [
    {
      title: '1. Acceptance of Terms',
      content: 'By accessing and using Followers Hub, you accept and agree to be bound by the terms and provision of this agreement.'
    },
    {
      title: '2. Services Description',
      content: 'Followers Hub provides social media growth services including followers, likes, views, comments, and other engagement metrics across various platforms including Facebook, Instagram, TikTok, Twitter, and YouTube.'
    },
    {
      title: '3. User Responsibilities',
      content: 'Users must: (a) provide accurate information; (b) maintain account security; (c) comply with platform terms of service; (d) use services for lawful purposes only; (e) not attempt to manipulate or abuse our systems.'
    },
    {
      title: '4. Payment Terms',
      content: 'All payments are processed securely through our payment partners. Prices are subject to change without notice. Refunds are available within 30 days of purchase if services are not delivered as specified.'
    },
    {
      title: '5. Service Delivery',
      content: 'We strive to deliver all services within the specified timeframe. Delivery times may vary based on package size and platform. We do not guarantee specific results but commit to delivering the ordered quantity.'
    },
    {
      title: '6. Privacy and Data Protection',
      content: 'Your privacy is important to us. Please review our Privacy Policy which explains how we collect, use, and protect your information when you use our services.'
    },
    {
      title: '7. Prohibited Activities',
      content: 'Users may not: (a) use services for illegal purposes; (b) attempt to harm our systems; (c) engage in fraudulent activities; (d) violate platform terms of service; (e) resell or redistribute services without permission.'
    },
    {
      title: '8. Intellectual Property',
      content: 'All content, trademarks, and intellectual property on the Followers Hub platform remain the property of Followers Hub. Users retain ownership of their social media accounts and content.'
    },
    {
      title: '9. Disclaimers',
      content: 'Followers Hub is not affiliated with any social media platforms. Results may vary. We make no guarantees about specific outcomes or platform algorithm changes.'
    },
    {
      title: '10. Limitation of Liability',
      content: 'Followers Hub shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our services.'
    },
    {
      title: '11. Termination',
      content: 'We reserve the right to terminate or suspend access to our services at any time, with or without cause, without prior notice.'
    },
    {
      title: '12. Changes to Terms',
      content: 'We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting. Your continued use of services constitutes acceptance of modified terms.'
    }
  ];

  return (
    <div className="pt-16">
      {/* Header */}
      <section className="hero-gradient text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Terms of Service
            </h1>
            <p className="text-xl text-purple-100 max-w-3xl mx-auto">
              Please read these terms carefully before using our services
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8 text-center">
            <p className="text-gray-600">
              Last updated: <span className="font-semibold">{lastUpdated}</span>
            </p>
          </div>

          <div className="space-y-12">
            {sections.map((section, index) => (
              <div key={index} className="border-b border-gray-200 pb-8 last:border-b-0">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">
                  {section.title}
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  {section.content}
                </p>
              </div>
            ))}
          </div>

          {/* Contact Information */}
          <div className="mt-12 p-8 bg-purple-50 rounded-lg">
            <h3 className="text-xl font-bold text-gray-800 mb-4">
              Questions About These Terms?
            </h3>
            <p className="text-gray-600 mb-6">
              If you have any questions about these Terms of Service, please contact us:
            </p>
            <div className="space-y-2">
              <p className="text-gray-700">
                <strong>Email:</strong> support@followershub.com
              </p>
              <p className="text-gray-700">
                <strong>Phone:</strong> +1 (555) 123-4567
              </p>
              <p className="text-gray-700">
                <strong>Address:</strong> 123 Business St, Suite 100, New York, NY 10001
              </p>
            </div>
          </div>

          {/* Agreement Statement */}
          <div className="mt-12 text-center">
            <div className="inline-block p-6 bg-purple-100 rounded-lg">
              <p className="text-purple-800 font-medium">
                By using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Navigation */}
      <section className="py-16 bg-gradient-to-br from-purple-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold gradient-text mb-6">
              Quick Links
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
              <Link to="/privacy" className="card p-4 text-center hover:scale-105 transition-transform duration-300">
                <span className="text-purple-600 font-medium">Privacy Policy</span>
              </Link>
              <Link to="/about" className="card p-4 text-center hover:scale-105 transition-transform duration-300">
                <span className="text-purple-600 font-medium">About Us</span>
              </Link>
              <Link to="/contact" className="card p-4 text-center hover:scale-105 transition-transform duration-300">
                <span className="text-purple-600 font-medium">Contact Support</span>
              </Link>
              <Link to="/packages" className="card p-4 text-center hover:scale-105 transition-transform duration-300">
                <span className="text-purple-600 font-medium">View Packages</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
